module.exports = __webpack_public_path__ + "static/img/top-logo.86a66be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top-logo.png
// module id = 457
// module chunks = 1